// react
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { DYNAMIC_ROUTES } from 'router';

// hooks
import { useCareProfile } from 'hooks';
import { useGoBack } from 'hooks/useGoBack';

// components
import { FormCompletePage } from '@karehero/llama/pwa/pages/FormCompletePage/FormCompletePage';
import { CareProfileCategoryID } from '@karehero/models';

/**
 * AttendanceAllowanceComplete is the dashboard page.
 */
export const AttendanceAllowanceComplete = () => {
  // hooks
  const navigate = useNavigate();
  const goBack = useGoBack();
  const { category, toLastFormPage, handleSubmit } = useCareProfile({
    categoryID: CareProfileCategoryID.AttendanceAllowance,
  });

  // methods
  const handleNext = useCallback(() => {
    handleSubmit();
    navigate(DYNAMIC_ROUTES.CARE_PROFILE_CATEGORY_SUCCESS(category?.id), {
      replace: true,
    });
  }, [handleSubmit, navigate, category]);

  return (
    <FormCompletePage
      onBack={goBack}
      title='Attendance Allowance'
      isComplete={category?.progress?.isComplete || false}
      items={[
        {
          icon: 'check-circle',
          text: 'Review your Attendance Allowance answers to ensure all the needs captured are correct',
        },
        {
          icon: 'user',
          text: 'Once submitted you can chat to your Care Expert regarding your Attendance Allowance',
        },
      ]}
      onSubmit={handleNext}
      onPrevious={() =>
        navigate(toLastFormPage, { replace: true, state: { back: true } })
      }
      isSubmitDisabled={!category?.progress?.isComplete}
    />
  );
};

export default AttendanceAllowanceComplete;
